import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import SesHeader from "../header";
import styles from "./styles.module.scss";
import cn from "classnames";

const summaryInterstitial = () => {
    const location = useLocation();
    const { totalQuestions, answered, notAnswered, phrases, cobrandingLink } =
        location?.state;
    const navigate = useNavigate();

    const onClickHandler = () => {
        navigate("/");
    };
    return (
        <div className="g-container_12 flex_col align-items_start g1 g2_mobile p2 py3_tablet py5_tablet">
            <div className="container bg01 roundness_1">
                <div className="g-container_12 p4 py3_tablet px2_mobile flex_col align-items_start g5 g3_mobile">
                    <div className="g-item_12 flex_col align-items_center justify-content_center align-self-stretch g1">
                        <SesHeader
                            clientCobranding={cobrandingLink}
                            isWarmUp={false}
                        />
                    </div>
                    <div className="g-item_12 flex_col align-items_start align-self-stretch">
                        <h3 className={styles?.headingStyle}>
                            {phrases?.["26000097"]}
                        </h3>
                        <p className={cn("mt2 mb0", styles?.subtitleStyle)}>
                            {phrases?.["1000000"]}
                        </p>
                        <div className={cn("px3 mt5", styles?.statsBox)}>
                            <div className={styles?.columContainer}>
                                <div className={styles?.imageStyle}>
                                    <span className="material-icons-outlined">
                                        assignment
                                    </span>
                                </div>
                                <div>
                                    <p className="m0 text-02">
                                        {phrases?.["26000100"]}
                                    </p>
                                    <p className={styles?.answerCount}>
                                        {totalQuestions}
                                    </p>
                                </div>
                            </div>
                            <div className={styles?.columContainer}>
                                <div className={styles?.imageStyle}>
                                    <span className="material-icons-outlined">
                                        assignment_turned_in
                                    </span>
                                </div>
                                <div>
                                    <p className="m0 text-02">
                                        {phrases?.["26000098"]}
                                    </p>
                                    <p className={styles?.answerCount}>
                                        {answered}
                                    </p>
                                </div>
                            </div>
                            <div className={styles?.columContainer}>
                                <div className={styles?.imageStyle}>
                                    <span className="material-icons-outlined">
                                        assignment_late
                                    </span>
                                </div>
                                <div>
                                    <p className="m0 text-02">
                                        {phrases?.["26000099"]}
                                    </p>
                                    <p className={styles?.answerCount}>
                                        {notAnswered}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="g-item_12 flex_col align-items_end justify-content_center align-self-stretch g4">
                        <div className="flex align-self-stretch align-items_center justify-content_center full-width">
                            <div className=" full-width"></div>
                        </div>
                        <div className="flex g4 align-items_center justify-content_end">
                            <button
                                className="button-primary"
                                onClick={onClickHandler}
                            >
                                {phrases?.["10928"]}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default summaryInterstitial;
